export default __webpack_public_path__ + "static/media/chat_mini.2f45c1d1.svg";